import Config from "config/config";
import Cookies from "js-cookie";

const Tools = {
    completeUrl : (url: string) => {
        if(!/^http/ig.test(url)){
            const port = +location.port;
            url = `${location.protocol}//${location.hostname}${port != 80 && port != 443 ? (':' + port) : ''}` + url
        }
        return url ;
    },
    decodeUrl : (encodeUrl: string) => {
        if(/^http.*$/ig.test(encodeUrl)) return encodeUrl ;
        return atob(encodeUrl.split('').reverse().join('')) 
    },
    disponseUrl : (url: string) => {
        // console.info(url, Config.routePrefix)
        if(/^http.*$/ig.test(url)) return url ;
        return Config.routePrefix + url ;
    },
    getLoginUrl : () => {
        return Config.platformLoginUrl ;
    },
    goLogin : () => {
        location.href = Tools.getLoginUrl()
    },
    getWebsiteUrl : () => {
        return Config.websiteUrl ;
    },
    removeCookie : (key: string) => {
        const options: any= {};
        if(/^https.*?$/ig.test(Config.platformUrl)){
            options.domain = 'mockuplabs.ai'
        }
        Cookies.remove(key, options);
    }
}

export default Tools ;